import { GetRecipesQuery_recipes_Recipe } from '../__generated__/queries-recipe';
import { baseRecipesURLs } from '../components/InternalLinkModal/useInternalLinksGetter';

export const getFrontUrl = (
  recipe?: GetRecipesQuery_recipes_Recipe,
): string | undefined => {
  if (!recipe?.recipeUrls?.[0]?.url?.path) {
    return undefined;
  }

  const basePath = baseRecipesURLs[recipe.brandKey];
  const { path } = recipe.recipeUrls[0].url;

  return basePath ? `${basePath}${path}` : undefined;
};
